import { render, staticRenderFns } from "./WorldSlider.vue?vue&type=template&id=c6d9906e&scoped=true"
import script from "./WorldSlider.vue?vue&type=script&lang=js"
export * from "./WorldSlider.vue?vue&type=script&lang=js"
import style0 from "./WorldSlider.vue?vue&type=style&index=0&id=c6d9906e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6d9906e",
  null
  
)

export default component.exports